import * as React from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter, Routes, Route } from "react-router-dom";

import ProductPage from "pages/product"
import ProductAddPage from "pages/product/add"
import ProductEditPage from "pages/product/edit"
import ProductVariantPage from "pages/product/variant"
import ProductPricePage from "pages/product/price"

import ProductOption from "pages/product_option"
import ProductOptionAddPage from "pages/product_option/add"
import OrderList from "pages/order/List"
import OrderDetail from "pages/order/Detail"
import OrderEdit from "pages/order/Edit"
import Voucher from "pages/voucher/List"
import OrderPaymentList from "pages/order-payment/List"
import DebtList from "pages/debt/List"
import CustomerList from "pages/customer/List"
import Tags from "pages/tag"
import ProductCategory from "pages/category"
import WebsiteGeneralSetting from "pages/website_setting/General"
import WebsitePaymentSetting from "pages/website_setting/Payment"
import PrintSetting from "pages/website_setting/Print"
import OrderSetting from "pages/website_setting/Order"
import ProductOptionAddParentPage from "pages/product_option/add_parentoption"
import PointConfig from "pages/loyalty/Point"
import UserList from "pages/setting/User"
import InviteList from "pages/account/InviteList"
import ShopList from "pages/account/ShopList"
import HomePageSetting from "pages/website_setting/home_page"
import ShippingFee from "pages/website_setting/Shippingfee"
import CommissionSetting from "pages/collaborator/CommissionSetting"
import Collaborators from "pages/collaborator/User"
import CollaboratorOrder from "pages/collaborator-user/order/List"
import CollaboratorDashboard from "pages/collaborator-user/Dashboard"
import CollaboratorProduct from "pages/collaborator-user/product"
import CollaboratorOrderDetail from "pages/collaborator-user/order/Detail"
import CollaboratorWithdraw from "pages/collaborator/Withdraw"
import WebsiteReport from "pages/report/website"
import Dashboard from "pages/report/dashboard"
import { useAuth } from "contexts/auth"

//     { label: "Quản lý sản phẩm", value: "product.all" },
//     { label: "Quản lý đơn hàng", value: "order.all" },
//     { label: "Quản lý khách hàng", value: "customer.all" },
//     { label: "Quản lý công nợ", value: "debt.all" },
//     { label: "Quản lý voucher", value: "voucher.all" },
//     { label: "Cấu hình shop", value: "setting.all" },
// ]
const PageRoutes = () => {
  const { user } = useAuth();
  const [routes, setRoutes] = React.useState([]);
  var defaultPage = null;
  switch (user.work_space?.role) {

    case "ctv":
      defaultPage = <CollaboratorDashboard></CollaboratorDashboard>
      break;

    default:
      defaultPage = <Dashboard></Dashboard>
      break;
  }
  const allRouters = [
    { element: <Route path="/vouchers" element={<Voucher></Voucher>} />, permission: "product.all" },
    { element: <Route path="/product/add" element={<ProductAddPage></ProductAddPage>} />, permission: "product.all" },
    { element: <Route path="/product/info/:id" element={<ProductAddPage></ProductAddPage>} />, permission: "product.all" },
    { element: <Route path="/product/variant/:id" element={<ProductVariantPage></ProductVariantPage>} />, permission: "product.all" },
    { element: <Route path="/product/price/:id" element={<ProductPricePage></ProductPricePage>} />, permission: "product.all" },
    { element: <Route path="/product/edit/:id" element={<ProductEditPage></ProductEditPage>} />, permission: "product.all" },
    { element: <Route path="/products" element={<ProductPage></ProductPage>} />, permission: "product.all" },
    { element: <Route path="/product_option/" element={<ProductOption></ProductOption>} />, permission: "product.all" },
    { element: <Route path="/product_option/add" element={<ProductOptionAddPage></ProductOptionAddPage>} />, permission: "product.all" },
    { element: <Route path="/product_option/edit/:parentid/:id" element={<ProductOptionAddPage></ProductOptionAddPage>} />, permission: "product.all" },
    { element: <Route path="/product_option/add_parentoption" element={<ProductOptionAddParentPage></ProductOptionAddParentPage>} />, permission: "product.all" },
    { element: <Route path="/product_option/edit_parentoption/:id" element={<ProductOptionAddParentPage></ProductOptionAddParentPage>} />, permission: "product.all" },
    { element: <Route path="/product_tag/" element={<Tags></Tags>} />, permission: "product.all" },
    { element: <Route path="/product_category/" element={<ProductCategory></ProductCategory>} />, permission: "product.all" },
    { element: <Route path="/customers" element={<CustomerList></CustomerList>} />, permission: "customer.all" },
    { element: <Route path="/payment-confirm" element={<OrderPaymentList></OrderPaymentList>} />, permission: "" },
    { element: <Route path="/debt" element={<DebtList></DebtList>} />, permission: "debt.all" },
    { element: <Route path="/orders" element={<OrderList></OrderList>} />, permission: "order.all" },
    { element: <Route path="/order/edit/:id" element={<OrderEdit></OrderEdit>} />, permission: "order.all" },
    { element: <Route path="/order/add/:id?" element={<OrderEdit></OrderEdit>} />, permission: "order.all" },
    { element: <Route path="/order/:id" element={<OrderDetail></OrderDetail>} />, permission: "order.all" },
    { element: <Route path="/website/setting/general/" element={<WebsiteGeneralSetting></WebsiteGeneralSetting>} />, permission: "" },
    { element: <Route path="/website/setting/homepage/" element={<HomePageSetting></HomePageSetting>} />, permission: "" },
    { element: <Route path="/website/setting/payment/" element={<WebsitePaymentSetting></WebsitePaymentSetting>} />, permission: "" },
    { element: <Route path="/website/setting/print/" element={<PrintSetting></PrintSetting>} />, permission: "" },
    { element: <Route path="/website/setting/order/" element={<OrderSetting></OrderSetting>} />, permission: "" },
    { element: <Route path="/website/setting/shippingfee" element={<ShippingFee></ShippingFee>} />, permission: "" },
    { element: <Route path="/loyalty/setting/point/" element={<PointConfig></PointConfig>} />, permission: "setting.all" },
    { element: <Route path="/setting/user" element={<UserList></UserList>} />, permission: "setting.all" },
    { element: <Route path="/collaborator/commission" element={<CommissionSetting></CommissionSetting>} />, permission: "setting.all" },
    { element: <Route path="/collaborator/users" element={<Collaborators></Collaborators>} />, permission: "setting.all" },
    { element: <Route path="/collaborator/dashboard" element={<CollaboratorDashboard></CollaboratorDashboard>} />, role: "ctv" },
    { element: <Route path="/collaborator/order" element={<CollaboratorOrder></CollaboratorOrder>} />, role: "ctv" },
    { element: <Route path="/collaborator/order/:id" element={<CollaboratorOrderDetail></CollaboratorOrderDetail>} />, role: "ctv" },
    { element: <Route path="/collaborator/product" element={<CollaboratorProduct></CollaboratorProduct>} />, role: "ctv" },
    { element: <Route path="/collaborator/withdraw/:id" element={<CollaboratorWithdraw></CollaboratorWithdraw>} />, permission: "setting.all" },
    { element: <Route path="/website/report/" element={<WebsiteReport></WebsiteReport>} />, permission: "" },
    { element: <Route path="/dashboard" element={<Dashboard></Dashboard>} />, permission: "" },
    { element: <Route path="/" element={defaultPage} />, permission: "" },
  ]









  React.useEffect(() => {

    var wp = user.work_space;
    var permissions = wp.permissions ?? [];

    var items = [...allRouters];
    if (!["admin", "owner"].includes(wp.role)) {

      items = items.filter(menu => {
        //ko cần quyền
        if (!menu.permission) {
          return true;
        }
        //lọc menu
        if (permissions.includes(menu.permission)) {
          return true;
        }
        if (wp.role == menu.role) {
          return true;
        }
        return false;
      })

    }
    setRoutes(items);
  }, [user])





















  return (
    <Routes>

      {routes.map(x => {

        var element = x?.element;
        return element;

      })}
      <Route path="/" element={<OrderList></OrderList>} />
      <Route path="/account/invitelist" element={<InviteList></InviteList>} />
      <Route path="/account/shoplist" element={<ShopList></ShopList>} />,
    </Routes>
  );
};

export default React.memo(PageRoutes);
